export default "__VITE_ASSET__BPHZ8v31__"